import { render, staticRenderFns } from "./bookfrm.vue?vue&type=template&id=773f1218"
import script from "./bookfrm.vue?vue&type=script&lang=js"
export * from "./bookfrm.vue?vue&type=script&lang=js"
import style0 from "./bookfrm.vue?vue&type=style&index=0&id=773f1218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports